import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=3d8afe40&scoped=true&"
import script from "./ProductEditor.vue?vue&type=script&lang=js&"
export * from "./ProductEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditor.vue?vue&type=style&index=0&id=3d8afe40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8afe40",
  null
  
)

export default component.exports